/**
 * Runtime config helpers over window.YOINK_CONFIG (set by the PHP shell
 * before the bundle loads).
 *
 * apiBase: where the same-origin PHP API endpoints (google-proxy.php,
 * notifications.php, …) live. On the staging subdomain /adventure/api is
 * a real directory (v2/adventure/api/ wrappers); on production the files
 * are inside the theme, so yoink-page.php passes the theme path
 * (…/wp-content/themes/astra/api). The fallback keeps older shells and
 * the unit suites (no YOINK_CONFIG) on the subdomain shape.
 */
export function getApiBase() {
  return (typeof window !== 'undefined' && window.YOINK_CONFIG?.apiBase) || '/adventure/api';
}
